module.exports = __webpack_public_path__ + "static/media/twitter-circle-border.1789b6f3.svg";